import { inject, Injectable } from "@angular/core";
import {BaseComponent} from "@wms/components";
import {WidgetPropertiesProvider} from "@wms/design-container";
import {runtimeEventManager} from "@wm/core";
import {FileService} from "@wms/services";

@Injectable({
  providedIn: 'root'
})

export class WmxWidgetsManager extends BaseComponent {
  private wp: WidgetPropertiesProvider;
  constructor(private fileService : FileService) {
    super();
    this.wp = inject(WidgetPropertiesProvider);
    runtimeEventManager.setService('WmxWidgetsManager', this);
  }


  loadWmxWidgetConfig(componentName: any) {
    return this.fileService.read(`../project/src/main/webapp/extensions/components/src/${componentName}/wmx.json`).then(res => JSON.parse(res));
  }

  getWMXComponents() {
    let wmxWidgetsSubGroup: any = this.wp.addSubGroup(
      {
        "name": "custom-components",
        "namekey": "LABEL_WM_EXT_WIDGETS",
        "parent": "WmxWidgets",
        "widgets": [],
        "filteredWidgets": []
      }
    );
    if (wmxWidgetsSubGroup) {
      wmxWidgetsSubGroup.widgets = [];
    }

    this.fileService.readDir(`../project/src/main/webapp/extensions/components/src`).then((data: any) => {
      data.files.forEach( (file: any, index: number) => {
        this.loadWmxWidgetConfig(file.name).then((res) => {
          let widgetData = {
            'id': index + 1,
            'name': res.displayName,
            'displayName': res.displayName,
            'desc': res.description,
            'iconUrl': res.iconUrl && '/studio/services/projects/' + this.projectService.getProjectId() + '/resources/content/project/src/main/webapp/extensions/components/src/'+res.name+'/'+res.iconUrl,
            'iconclass': 'wms wms-widgets',
            'category': 'wmx-component',
            'isDraggable': true,
            'widgetType': 'wmx-component',
            'dropEffectCls': 'block wmx-component',
            'defaults': {
              'componentName' : res.name
            },
            'version': res.version,
            'versionId': "1.0"
          }
          // @ts-ignore
          widgetData['_defaults'] = JSON.stringify(widgetData.defaults);
          wmxWidgetsSubGroup.widgets.push(widgetData);
        });
      })
    })
  }


}
